import { add, endOfDay, startOfDay, subDays, subMonths, subWeeks, subYears } from "date-fns";

const rangesModel: DateRangePicker.Range[] = [
  {
    isActive: false,
    label: 'Today',
    key: 'TODAY',
    startDate: startOfDay( new Date() ),
    endDate: endOfDay(new Date())

  },
  {
    isActive: false,
    label: 'Last 7 Days',
    key: 'FROM_LAST_WEEK',
    startDate: startOfDay(subWeeks(new Date(), 1)),
    endDate: endOfDay(new Date())
  },
  {
    isActive: false,
    label: 'Last 14 Days',
    key: 'FROM_LAST_TWO_WEEKS',
    startDate: startOfDay(subWeeks(new Date(), 2)),
    endDate: endOfDay(new Date())
  },
  {
    isActive: false,
    label: 'Last 30 Days',
    key: 'FROM_LAST_MONTH',
    startDate: startOfDay(subDays(new Date(), 30)),
    endDate: endOfDay(new Date())
  },
  {
    isActive: false,
    label: 'Last 3 Months',
    key: 'FROM_LAST_THREE_MONTHS',
    startDate: startOfDay(subMonths(new Date(), 3)),
    endDate: endOfDay(new Date())
  },
  {
    isActive: false,
    label: 'Last 6 Months',
    key: 'FROM_LAST_SIX_MONTHS',
    startDate: startOfDay(subMonths(new Date(), 6)),
    endDate: endOfDay(new Date())
  },
  {
    isActive: false,
    label: 'Last 12 Months',
    key: 'FROM_LAST_YEAR',
    startDate: startOfDay(subMonths(new Date(), 12)),
    endDate: endOfDay(new Date())
  }
];

export default rangesModel;
